import type { ComponentProps } from 'react'
import { cn } from '@/helpers/utils'

function Empty({ className, ...props }: ComponentProps<'div'>) {
	return (
		<div
			className={cn(
				'flex h-full flex-col items-center justify-center gap-4 p-8',
				className
			)}
			{...props}
		/>
	)
}

function EmptyHeader({ className, ...props }: ComponentProps<'div'>) {
	return (
		<div
			className={cn(
				'flex flex-col items-center gap-3 text-center',
				className
			)}
			{...props}
		/>
	)
}

function EmptyMedia({
	className,
	variant = 'icon',
	children,
	...props
}: ComponentProps<'div'> & { variant?: 'icon' | 'image' }) {
	return (
		<div
			className={cn(
				'flex items-center justify-center',
				variant === 'icon' &&
					'size-12 rounded-full bg-neutral-100 text-neutral-500 [&>svg]:size-6',
				className
			)}
			{...props}
		>
			{children}
		</div>
	)
}

function EmptyTitle({ className, ...props }: ComponentProps<'h3'>) {
	return (
		<h3
			className={cn('font-medium text-base text-neutral-900', className)}
			{...props}
		/>
	)
}

function EmptyDescription({ className, ...props }: ComponentProps<'p'>) {
	return (
		<p className={cn('text-neutral-500 text-sm', className)} {...props} />
	)
}

export { Empty, EmptyHeader, EmptyMedia, EmptyTitle, EmptyDescription }
